import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common';
import { NewsletterSubscriptionFacade } from './newsletter-subscription.facade';

@Injectable({
  providedIn: 'root',
})
export class NewsletterSubscriptionGuard {
  constructor(private newsletterSubscriptionFacade: NewsletterSubscriptionFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      queryParams: { token },
    } = route;
    return checkStoreState(this.newsletterSubscriptionFacade, token);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.newsletterSubscriptionFacade);
  }
}
